import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-primary fw-medium py-2 px-3 w-100"
}
const _hoisted_10 = { class: "d-flex align-items-center justify-content-center py-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

import {ref} from "vue";
import {useAuthStore} from "@/stores/auth";
import {useRoute, useRouter} from "vue-router";
import api from "@/api/axios"; // Import axios API instance


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const username = ref("");
const password = ref("");
const loading = ref(false);
const errorMessage = ref("");

const handleLogin = async () => {
  loading.value = true;
  errorMessage.value = "";

  try {
    // Ensure Sanctum CSRF protection is in place
    await api.get("/sanctum/csrf-cookie");

    // Send login request correctly
    const response = await api.post("/auth/login", {
      username: username.value,
      password: password.value,
    });

    // Ensure authStore correctly processes the response
    authStore.setUser(response.data.data); // Set user data in store

    // Save the token in localStorage
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("user", JSON.stringify(response.data.data));

    // After login, set the token for further API requests
    api.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;

    //console.log('User and Token:', response.data.data, response.data.token);
    console.log('user_id', response.data.data.id)


    // Redirect after successful login
    if (route.fullPath.includes('legal')) {
      window.location.href = '/legal/index';
    } else {
      if (response.data.data.id === 1) {
        window.location.href = "/tasks/manage";
      } else {
        window.location.href = "/tasks/index";
      }
    }

  } catch (error: any) {
    console.log(error);
    if (error.response && error.response.data) {
      errorMessage.value = error.response.data.message || "Ошибка входа";
    } else {
      errorMessage.value = "An unexpected error occurred.";
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "login"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-inline-block mb-4\"><img src=\"/images/viavox_group_logotyp.png\" class=\"rounded-3 for-light-logo\" alt=\"login\"><img src=\"/images/viavox_group_logotyp.png\" class=\"rounded-3 for-dark-logo\" alt=\"login\"></div><h3 class=\"fs-28 mb-2\">Авторизация</h3><p class=\"fw-medium fs-16 mb-4\"></p>", 3)),
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleLogin, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label text-secondary" }, "Логин", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-55",
                placeholder: "Введите ваш логин",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, username.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label text-secondary" }, "Пароль", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control h-55",
                placeholder: "Введите ваш пароль",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, password.value]
              ])
            ]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, " login ", -1)),
                  (!loading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Войти"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "Выполняется вход..."))
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})